import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcReportHandler } from './rpc-report-handler';
import { RpcReportDataInbound, RpcReportDataInternal, RpcReportKey } from './rpc-report-model';

/**
 * Rpc report subject interface.
 */
export interface RpcReportSubject extends Subject<DeferredData<RpcReportDataInbound, void>> {}

/**
 * The class to implement report with Subject server.
 */
export class RpcReportSubjectServer extends RpcSubjectServer<RpcReportDataInbound, void> implements RpcReportHandler {
    /**
     * Initializes a new instance of the RpcReportSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcReportKey.command);
    }

    /**
     * The handler to respond a request for report call.
     *
     * @param data The report object.
     * @return Promise<void> the promise object.
     */
    public handler(data: RpcReportDataInternal): Promise<void> {
        const result: RpcReportDataInbound = { ...data, ...this.rpc.rpcManager.getSourceStatus(data.sourceName, data.sourceSubName) };
        return this.processNextForSubject(RpcReportKey.command, result);
    }
}
